
import React, { memo } from "react";
import Label from "components/general/Label"
import useViewport from "components/general/useViewPort";
import { arraysEqual } from "helpers/utils";
import { isSection, isFencingRR } from "../helper/MpnHelpers";

const TableExpanded = memo((props) => {
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs"
    const { row } = props;

    //Riding
    const itemEq = row?.items?.find(i => isSection(i?.eventUnit?.code, 'EQ'))
    const ptsEq = itemEq?.resPoints
    const resEq = itemEq?.resValue
    const rnkEq = itemEq?.rank ? itemEq?.rank : ''

    //Fencing
    const itemFeBR = row?.items?.find(i => !isFencingRR(i?.eventUnit?.code) && isSection(i?.eventUnit?.code, 'FE'))
    const ptsFeBR = itemFeBR?.resPoints

    const itemFeRR = row?.items?.find(i => isFencingRR(i?.eventUnit?.code))
    const ptsFeRR = itemFeRR?.resPoints

    const itemFe = row?.extendedResults?.find(er => er?.er_code === 'FENCING' && er?.er_type === 'ER');
    const ptsFe = itemFe?.er_value;
    const rnkFe = itemFeBR?.rank ? itemFeBR?.rank : '';

    //Swimming
    const itemSw = row?.items?.find(i => isSection(i?.eventUnit?.code, 'SW'))
    const ptsSw = itemSw?.resPoints
    const resSw = itemSw?.resValue
    const rnkSw = itemSw?.rank ? itemSw?.rank : ''

    //Laser
    const itemLr = row?.items?.find(i => isSection(i?.eventUnit?.code, 'LR'))
    const ptsLr = itemLr?.resPoints
    const resLr = itemLr?.resValue
    const rnkLr = itemLr?.rank

    const xl = (
        <table className="w-100 table-borderless">
            <thead>
                <tr>
                    <td className="text-start fw-bold w-40"><Label data="HeaderEvents" /></td>
                    <td className="text-end fw-bold w-20"><Label data="HeaderPoints" /></td>
                    <td className="text-end fw-bold w-20"><Label data="HeaderRank" /></td>
                    <td className="text-end fw-bold w-10"></td>
                    <td className="text-end fw-bold w-10"><Label data="HeaderResult" /></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-start fw-bold"><Label data="Riding" /></td>
                    <td className="text-end">{ptsEq}</td>
                    <td className="text-end">{rnkEq}</td>
                    <td></td>
                    <td className="text-end">{resEq}</td>
                </tr>
                <tr>
                    <td className="text-start fw-bold"><Label data="HeaderFencing" /></td>
                    <td className="text-end">{ptsFe}</td>
                    <td className="text-end">{rnkFe}</td>
                    <td className="text-end fw-bold"><Label data="HeaderRRPoints" /></td>
                    <td className="text-end">{ptsFeRR}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td className="text-end fw-bold"><Label data="HeaderBRPoints" /></td>
                    <td className="text-end">{ptsFeBR}</td>
                </tr>
                <tr>
                    <td className="text-start fw-bold"><Label data="HeaderSwimming" /></td>
                    <td className="text-end">{ptsSw}</td>
                    <td className="text-end">{rnkSw}</td>
                    <td></td>
                    <td className="text-end">{resSw}</td>
                </tr>
                <tr>
                    <td className="text-start fw-bold"><Label data="LaserRun" /></td>
                    <td className="text-end">{ptsLr}</td>
                    <td className="text-end">{rnkLr}</td>
                    <td></td>
                    <td className="text-end">{resLr}</td>
                </tr>
            </tbody>
        </table>
    );

    return <>{isMobile ? xl : xl}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.res?.extendedResults, nextProps?.res?.extendedResults);
});


export default TableExpanded;

